import { Eye, EyeOff, RefreshCw } from 'lucide-react';
import { ComponentProps, forwardRef, useState } from 'react';
import {
  randomPassword,
  lower,
  upper,
  digits,
  symbols,
} from 'secure-random-password';

import { Button } from './ui/Button';
import { Input } from './ui/Input';

interface PasswordInputProps extends ComponentProps<'input'> {
  generatorButton?: {
    enable: boolean;
    onGenerate: (value: string) => void;
  };
}

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ generatorButton, ...props }, ref) => {
    const [isVisible, setIsVisible] = useState(false);

    function handleToggleIsVisible() {
      setIsVisible((value) => !value);
    }

    function handleGeneratePassword() {
      const password = randomPassword({
        length: 12,
        characters: [lower, upper, digits, symbols],
      });

      generatorButton?.onGenerate(password);
    }

    return (
      <div className="flex gap-2">
        <div className="relative w-full">
          <Input type={isVisible ? 'text' : 'password'} {...props} ref={ref} />

          <Button
            type="button"
            variant="ghost"
            size="sm"
            className="absolute right-0 top-0 h-full px-3 py-2 hover:bg-transparent"
            onClick={handleToggleIsVisible}
          >
            {isVisible ? (
              <EyeOff className="h-4 w-4" />
            ) : (
              <Eye className="h-4 w-4" />
            )}
            <span className="sr-only">
              {isVisible ? 'Ocultar senha' : 'Mostrar senha'}
            </span>
          </Button>
        </div>

        {generatorButton?.enable && (
          <Button
            type="button"
            variant="outline"
            onClick={handleGeneratePassword}
          >
            <RefreshCw className="h-4 w-4" />
            Generate
          </Button>
        )}
      </div>
    );
  },
);

PasswordInput.displayName = 'PasswordInput';
